import { render } from "./PlaceDetail.vue?vue&type=template&id=7b60028f&scoped=true"
import script from "./PlaceDetail.vue?vue&type=script&lang=js"
export * from "./PlaceDetail.vue?vue&type=script&lang=js"

import "./PlaceDetail.vue?vue&type=style&index=0&id=7b60028f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b60028f"]])

export default __exports__